"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nl_1 = __importDefault(require("date-fns/locale/nl")); //
const dateNlNL = {
    name: 'nl-NL',
    locale: nl_1.default
};
exports.default = dateNlNL;
